import { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { getDoc, doc, deleteDoc } from 'firebase/firestore'
import { toast } from 'react-toastify'

import { db } from '../firebase'
import { convertTime } from '../helpers/datetime_helper'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'
import Spinner from '../components/spinner'
import { getIconBySentiment } from '../components/icons'
import { IJournal, emptyJournal } from '../types/journal'

function Journal() {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [journal, setJournal] = useState<IJournal>(emptyJournal)
  const navigate = useNavigate() // Navigation

  useEffect(() => {
    const fetchJournal = async () => {
      if (id) {
        const docRef = doc(db, 'journals', id)
        const docSnap = await getDoc(docRef)

        if (docSnap.exists()) {
          const docInfo = docSnap.data()
          const data: IJournal = {
            id: docSnap.id,
            title: docInfo.title,
            date: docInfo.date,
            content: docInfo.content,
            sentiment: docInfo.sentiment
          }
          setJournal(data)
          setLoading(false)
        }
      }
    }

    fetchJournal()
  }, [id])

  async function deleteJournal(journal_id_to_delete: string) {
    await deleteDoc(doc(db, 'journals', journal_id_to_delete))
    toast.success('Successfully deleted a journal')
    navigate('/journals')
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <Layout>
      <MainTitle title={`Journal: ${journal.title} `} />
      <div
        id="title"
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
      >
        {journal.title}
      </div>
      <div
        id="date"
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
      >
        {convertTime(journal.date)}
      </div>
      <textarea
        id="content"
        rows={13}
        className="my-2 mr-4 w-full rounded-2xl bg-primary py-2 px-3 pb-24"
        value={journal.content}
      />

      <div className="flex justify-between pl-40">
        <div>{getIconBySentiment(journal.sentiment, 72)}</div>
        <Link
          to={`/journals/${id}/edit`}
          className="flex w-40 items-center justify-center rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
        >
          Edit
        </Link>
        <div
          className="flex w-40 items-center justify-center rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={() => {
            if (window.confirm(`Are you sure you wish to delete ${id}`))
              if (id) deleteJournal(id)
          }}
        >
          Delete
        </div>
      </div>
    </Layout>
  )
}

export default Journal
